import * as React from "react";
import styled from "styled-components";
import Image from "next/image";
import progressBar from "../../public/progressbar.png";
export interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number;
  children?: number;
  loading?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  visibility: visible;
`;
const ProgressDiv = styled.div<{ $value: number }>`
  min-width: 5%;
  width: ${props => props.$value}%;
  span {
    float: right;
  }
`;
const ProgressDivInner = styled(ProgressDiv)`
  background-color: ${props => props.theme.palette.inputBackground};
  border-radius: ${props => props.theme.borderRadius};
  height: 20px;
`;

export default function ProgressBar(props: ProgressBarProps) {
  return (
    <Container>
      <ProgressDiv $value={props.value}>
        <Image
          src={progressBar}
          width={90}
          height={90}
          alt="Tracksuit icon"
        ></Image>
      </ProgressDiv>
      <ProgressDivInner $value={props.value} />
    </Container>
  );
}
